import React from "react";
import { SelectionTabButton } from "../AllButton/SelectionTabButton";

export const DesktopTabDesign = ({ state, localProps }) => {
  return (
    <React.Fragment>
      <div className="service-top-tab-button" style={{ overflowX: "scroll" }}>
        <div className="btn-group " role="group" aria-label="Basic example">
          <SelectionTabButton
            buttonClass={
              state.casual_dining ? "top-tab-button-section-active" : ""
            }
            buttonIcon={require("../../../../../assets/images/ActionImages/order.svg")}
            buttonText="Casual / Fine Dining"
            onClick={localProps.casualDiningManagementButton}
          />
          <span className="btn-separator"></span>
          <SelectionTabButton
            buttonClass={
              state.fast_food_dining ? "top-tab-button-section-active" : ""
            }
            buttonIcon={require("../../../../../assets/images/ActionImages/order.svg")}
            buttonText="Fast Food and other"
            onClick={localProps.fastFoodOthersManagement}
          />
          <span className="btn-separator"></span>
          <SelectionTabButton
            buttonClass={
              state.hospitality_hotels ? "top-tab-button-section-active" : ""
            }
            buttonIcon={require("../../../../../assets/images/ActionImages/order.svg")}
            buttonText="Hospitality & Hotels"
            onClick={localProps.hospitalityHotelsManagement}
          />
          <span className="btn-separator"></span>
          <SelectionTabButton
            buttonClass={
              state.multi_service_business
                ? "top-tab-button-section-active"
                : ""
            }
            buttonIcon={require("../../../../../assets/images/ActionImages/order.svg")}
            buttonText="Multi Service Business"
            onClick={localProps.multiServiceManagementButton}
          />
        </div>
      </div>
      {/* <div className="service-top-tab-button"> */}
      {/* </div> */}
    </React.Fragment>
  );
};
